<template>
  <div class="wallet-page">
    <div class="breadcrumb-wrap">
      <h2>Affiliate</h2>
      <ul class="breadcrumb">
        <li>
          <router-link :to="{name: 'Home'}"><i class="bx bxs-home"></i>Home</router-link>
        </li>
        <li>
          <router-link :to="{name: 'Dashboard'}"><i class="bx bxs-dashboard"></i>Dashboard</router-link>
        </li>
        <li>
          <span>Affiliate</span>
        </li>
      </ul>
    </div>
    <div class="invite-box">
      <div class="title">
        <h2>Referral Info</h2>
      </div>
      <div class="item">
        <div class="item-info">
          <h4>Invite Code</h4>
          <div class="input-wrap">
            <el-input :value="`${userOverview.code}`"></el-input>
            <el-button @click="copy(userOverview.code)"><i class="el-icon-copy-document"></i>Copy</el-button>
          </div>
        </div>
        <div class="item-info">
          <h4>Invite Link</h4>
          <div class="input-wrap">
            <el-input :value="inviteLink"></el-input>
            <el-button @click="copy(inviteLink)"><i class="el-icon-copy-document"></i>Copy</el-button>
          </div>
        </div>
        <div class="item-social">
          <h4>Share to</h4>
          <!-- <share :config="config"></share> -->

          <div class="socials">
            <a href="#"><img src="/assets/images/icons/socials/facebook.png" alt="Icon"></a>
            <a href="#"><img src="/assets/images/icons/socials/twitter.png" alt="Icon"></a>
            <a href="#"><img src="/assets/images/icons/socials/whatsapp.png" alt="Icon"></a>
            <a href="#"><img src="/assets/images/icons/socials/telegram.png" alt="Icon"></a>
          </div>
        </div>
        <div class="item-tip">
          <i class="el-icon-info"></i>
          <em>Note: To use the referral link and receive the commission, you need to buy a minimum investment package of $100</em>
          <router-link :to="{name: 'BuyPackage'}"> Invest Now</router-link>
        </div>
      </div>
    </div>
    <el-collapse v-model="activeLevel">
      <template v-for="(member, index) in affMemberLevels">
        <el-collapse-item :key="index" :title="`Affiliate Members: Level ${index + 1}`" :name="index + 1">
          <div class="table-box">
            <div class="total-member" v-if="affMember[member]">
              Total referral members: {{affMember[member].length}}
              <template v-if="totalSales[index]">
                <br>
                Total Sale: ${{totalSales[index]}}
              </template>
            </div>
            <div class="table-fixed-wrap">
              <div class="table-box-inner">
                <dl class="table-small">
                  <dt>
                    <div class="item-no">{{ $t('TEXT_NO') }}.</div>
                    <div class="width-1_5x">{{ $t('TEXT_USERNAME') }}</div>
                    <div class="flex-1">{{ $t('TEXT_REF_CODE') }}</div>
                    <div>{{ $t('TEXT_TOTAL_BUY') }}</div>
                    <div>{{ $t('TEXT_COMMISSION') }}</div>
                  </dt>
                  <template v-if="affMember[member].length">
                    <dd v-for="(child, index) in affMember[member]" :key="index">
                      <div class="item-no">{{ index + 1 }}</div>
                      <div class="width-1_5x">{{ child.username }}</div>
                      <div class="flex-1">{{ child.refCode }}</div>
                      <div>{{ child.totalBuy }}</div>
                      <div>{{ child.commission }}</div>
                    </dd>
                  </template>
                  <template v-else>
                    <dd class="no-data-wrap">
                      <div class="no-data">{{ $t('TEXT_NO_DATA') }}</div>
                    </dd>
                  </template>
                </dl>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </template>
    </el-collapse>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isLoadingData: false,
      showLevel: 'F1',
      activeLevel: [1]
    }
  },
  computed: {
    inviteLink () {
      return `${window.location.origin}?ref=${this.userOverview.code}`
    },
    userOverview () {
      return this.$store.getters.userOverview
    },
    ieoUserRefs () {
      return this.$store.getters.ieoUserRefs
    },
    affMember () {
      return this.$store.getters.affMember
    },
    affMemberLevels () {
      return Object.keys(this.affMember)
    },
    totalSales () {
      const output = []
      for (const key in this.affMember) {
        let temp = 0
        this.affMember[key].forEach((item) => {
          temp = temp + item.totalBuy
        })
        output.push(temp)
      }
      return output
    }
  },
  watch: {
    async activeLevel (n, o) {
      if (n.length > o.length) {
        const level = n[n.length - 1]
        await this.getAffMemberByLevel(level)
      }
    }
  },
  async created () {
    this.isLoadingData = true
    await this.$store.dispatch('getAffMember')
    this.isLoadingData = false
  },
  methods: {
    copy (text) {
      text = text + ''
      this.$copyText(text).then(e => {
        this.$store.dispatch('showSuccessMsg', this.$t('TEXT_COPIED', 'Copied'))
      })
    },
    async getAffMemberByLevel (level) {
      await this.$store.dispatch('getAffMemberByLevel', level)
    }
  }
}
</script>
